import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "./images";

export const HeroSection = () => (
  <section data-testid="hero-section" className="relative h-screen min-h-[600px] flex items-center overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={IMAGES.hero}
        alt="Luxury fabric texture"
        className="w-full h-full object-cover"
        style={{ transform: 'scale(1.05)' }}
      />
      <div className="hero-overlay absolute inset-0" />
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-2xl"
      >
        <div className="section-divider mb-8" />
        <h1 className="text-5xl md:text-7xl font-serif text-white tracking-tight leading-none mb-6">
          Crafting Fabrics.<br />Delivering Trust.
        </h1>
        <p className="text-base md:text-lg font-sans text-white/80 leading-relaxed mb-10 max-w-xl">
          75+ years of textile excellence, combining heritage craftsmanship with modern manufacturing for global markets.
        </p>
        <div className="flex flex-wrap gap-4">
          <Link to="/products">
            <Button
              data-testid="hero-explore-btn"
              className="bg-white text-[#0F172A] rounded-none px-8 py-6 text-xs uppercase tracking-[0.15em] font-sans font-medium hover:bg-white/90"
            >
              Explore Products
            </Button>
          </Link>
          <Link to="/contact">
            <Button
              data-testid="hero-contact-btn"
              variant="outline"
              className="border-white text-white rounded-none px-8 py-6 text-xs uppercase tracking-[0.15em] font-sans font-medium hover:bg-white hover:text-[#0F172A] bg-transparent"
            >
              Get in Touch <ArrowRight size={14} className="ml-2" />
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);
